import { render, staticRenderFns } from "./DeleteStore.vue?vue&type=template&id=190ed27c&scoped=true&"
import script from "./DeleteStore.vue?vue&type=script&lang=js&"
export * from "./DeleteStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190ed27c",
  null
  
)

export default component.exports